export default {"src":"/_next/static/image/public/images/ic_doctor_igp.be313fbdd6e22e4c38e890ad20e32927.svg","height":90,"width":90};